export default {
  data () {
    return {
      filters: [],
      currentPage: 1,
      totalRows: 1,
      perPage: 10
    }
  },
  methods: {
    getFilterElementVal (key, element) {
      let elementVal = ''
      let app = this
      if (key.includes('.')) {
        let keysValue = key.split('.')
        keysValue.map(function (item, index, array) {
          if (elementVal === '') {
            elementVal = element[item] !== undefined && element[item] !== null ? element[item] : ''
          } else {
            elementVal = elementVal[item] !== undefined && elementVal[item] !== null ? elementVal[item] : ''
          }
        })
      } else {
        elementVal = app.getEmptyStringOrLowerCase(element[key])
      }
      return elementVal
    },
    getEmptyStringOrLowerCase (text) {
      if (text === undefined || text === null) {
        return ''
      }
      return text.toString().toLowerCase()
    },
    checkAddressFilter (element, value) {
      let result = false
      let countryVal = element.country !== undefined && element.country !== null ? this.getEmptyStringOrLowerCase(element.country.name) : ''
      let cityVal = element.city !== undefined && element.city !== null ? this.getEmptyStringOrLowerCase(element.city) : ''
      let postalCodeVal = element.postalCode !== undefined && element.postalCode !== null ? this.getEmptyStringOrLowerCase(element.postalCode) : ''
      let addressVal = element.mainAddress !== undefined && element.mainAddress !== null ? this.getEmptyStringOrLowerCase(element.mainAddress) : ''

      if (countryVal.includes(value) || cityVal.includes(value) || postalCodeVal.includes(value) ||
      addressVal.includes(value)) {
        result = true
      }
      return result
    },
    checkProfileFilter (element, value) {
      let result = false
      let name = element.name !== undefined && element.name !== null ? this.getEmptyStringOrLowerCase(element.name) : ''
      let surname = element.surname !== undefined && element.surname !== null ? this.getEmptyStringOrLowerCase(element.surname) : ''

      if (name.includes(value) || surname.includes(value)) {
        result = true
      }
      return result
    }
  },
  computed: {
    elementsFiltered () {
      let filters = this.filters
      let app = this
      let filtered = this.elements.filter((element) => {
        let isVisible = true
        Object.keys(filters).forEach(function (key) {
          let value = app.getEmptyStringOrLowerCase(filters[key])
          if (value !== '') {
            if (key === 'address') {
              isVisible = app.checkAddressFilter(element, value)
            } else if (key === 'profile') {
              isVisible = app.checkProfileFilter(element, value)
            } else {
              let elementVal = app.getEmptyStringOrLowerCase(app.getFilterElementVal(key, element))
              if (!elementVal.includes(value)) {
                isVisible = false
              }
            }
          }
        })
        return isVisible
      })
      return filtered
    }
  },
  watch: {
    'elementsFiltered' () {
      this.totalRows = this.elementsFiltered.length
      this.currentPage = 1
    }
  }
}
